import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcWrite(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.248 18.497v-13a2.25 2.25 0 0 1 2.25-2.25h6.504a.75.75 0 0 1 0 1.5H5.498a.75.75 0 0 0-.75.75v13c0 .414.336.75.75.75h13a.75.75 0 0 0 .75-.75v-5.5a.75.75 0 0 1 1.5 0v5.5a2.25 2.25 0 0 1-2.25 2.25h-13a2.25 2.25 0 0 1-2.25-2.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.294 2.7a1.75 1.75 0 0 1 2.472.003l1.528 1.527a1.75 1.75 0 0 1 .003 2.473l-7.266 7.29a.75.75 0 0 1-.419.213l-3.499.532a.75.75 0 0 1-.854-.854l.532-3.5.027-.116a.75.75 0 0 1 .185-.303zm1.412 1.063a.25.25 0 0 0-.354 0l-7.117 7.09-.34 2.25 2.247-.343 7.091-7.116a.25.25 0 0 0 0-.353z"
  }));
}
var IcWrite = createNolIcon(/*#__PURE__*/forwardRef(SvgIcWrite));

export { IcWrite as I };
